module.exports = __webpack_public_path__ + "images/application/i-checkmark-green-3db977cf.png";